import { CreditCardPlusOutlineIcon } from './CreditCardPlusOutlineIcon';

/**
 * author: Austin Andrews
 * id FA914D65-0F2C-463D-A54F-9B0DE9FBEED3
 * name credit-card-plus-outline
 * version: 1.7.12
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/credit-card-plus-outline.svg
 * tags
 * - Banking 
 */
export const CreditCardAddIcon = CreditCardPlusOutlineIcon;
export default CreditCardAddIcon